/*
  In stock by default on every collection page we link to (Naoya, Quick Calls 2026-10-29,
  card instock-default-collections, his pick A; UIQ-039).

  Shopify's own Availability filter (`filter.v.availability=1`) does the hiding server-side, so
  pagination, the "179 of 191 products" count and the facet counts all agree with the grid, and
  the shopper sees an "In stock" pill that one tap clears. The theme cannot switch a filter on by
  itself, so this adds it to a collection link at the moment it is followed: the served HTML keeps
  clean links (the filtered page's canonical is the clean URL anyway), and a link inserted later
  (predictive search, the cart drawer, an article body) is covered without a MutationObserver.

  A shopper who arrives from outside (Google, a shared link) lands unfiltered; there the grid's
  per-page sink (sections/main-collection-product-grid.liquid, collection-grid-soldout-last) still
  puts sold-out cards at the end of each page.

  Left alone: a link that already carries any filter, links inside the filter form, the active
  filter pills and the pager (they carry the shopper's own filter state — "Clear all" must clear),
  /collections itself, and /collections/<c>/products/<p>. Removal: delete this file and the
  theme.liquid region instock-links.
*/
(() => {
  const PARAM = 'filter.v.availability';
  const SKIP = 'facet-filters-form, facet-remove, .active-facets, .pagination-wrapper, [data-shintop-all-stock]';
  const COLLECTION = /^\/collections\/[^/]+\/?$/;

  function addFilter(a) {
    if (!a.href) return;
    let url;
    try {
      url = new URL(a.href, location.href);
    } catch (e) {
      return;
    }
    if (url.origin !== location.origin || !COLLECTION.test(url.pathname)) return;
    if (a.closest(SKIP)) return;
    for (const key of url.searchParams.keys()) if (key.startsWith('filter.')) return;
    url.searchParams.set(PARAM, '1');
    a.href = url.pathname + url.search + url.hash;
  }

  function onEvent(event) {
    const a = event.target instanceof Element ? event.target.closest('a[href]') : null;
    if (a) addFilter(a);
  }

  // pointerdown covers mouse (left and middle), touch and pen before the navigation starts;
  // focusin covers the keyboard (the href is right before Enter is pressed); click catches a
  // synthetic or assistive-technology activation that fired neither.
  // A collection whose every product is sold out would open on "No products found": the grid
  // section marks that case (region instock-empty) and the page swaps to the unfiltered view,
  // sort kept. Only at load — a filter the shopper ticks later redraws the grid by innerHTML and
  // never runs this.
  if (document.querySelector('[data-shintop-instock-empty]')) {
    const url = new URL(location.href);
    url.searchParams.delete(PARAM);
    url.searchParams.delete('page');
    location.replace(url.pathname + url.search + url.hash);
    return;
  }

  document.addEventListener('pointerdown', onEvent, true);
  document.addEventListener('focusin', onEvent, true);
  document.addEventListener('click', onEvent, true);
})();
